import { Languages } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { cn } from "@/lib/utils";

interface LanguageToggleProps {
  /** Render light-on-dark styling (transparent nav over the hero) */
  light?: boolean;
  className?: string;
}

const LanguageToggle = ({ light = false, className }: LanguageToggleProps) => {
  const { language, setLanguage, t } = useLanguage();

  const base =
    "px-2.5 py-1 text-xs font-medium font-sans rounded-sm transition-colors";

  return (
    <div
      role="group"
      aria-label={t("nav.language")}
      className={cn(
        "flex items-center gap-1 rounded-sm border p-0.5",
        light ? "border-white/30" : "border-border",
        className,
      )}
    >
      <Languages
        className={cn("h-3.5 w-3.5 ml-1 mr-0.5", light ? "text-white/70" : "text-muted-foreground")}
        aria-hidden="true"
      />
      <button
        type="button"
        onClick={() => setLanguage("en")}
        aria-pressed={language === "en"}
        className={cn(
          base,
          language === "en"
            ? light
              ? "bg-white text-primary"
              : "bg-foreground text-background"
            : light
              ? "text-white/70 hover:text-white"
              : "text-muted-foreground hover:text-foreground",
        )}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => setLanguage("zh")}
        aria-pressed={language === "zh"}
        lang="zh-Hans"
        className={cn(
          base,
          language === "zh"
            ? light
              ? "bg-white text-primary"
              : "bg-foreground text-background"
            : light
              ? "text-white/70 hover:text-white"
              : "text-muted-foreground hover:text-foreground",
        )}
      >
        中文
      </button>
    </div>
  );
};

export default LanguageToggle;
